// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2kmMQ{position:relative;width:87%;margin:0 auto;min-height:100vh}@media(min-width:1440px){._2kmMQ{max-width:78rem;margin:3rem auto 1.5rem}}._2ePNx{padding-top:3rem;font-size:48px;font-size:3rem;font-weight:500;line-height:60px;line-height:3.75rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){._2ePNx{font-size:2rem;line-height:2.5rem}}._1Vl3K{margin:1.5rem 0 2rem;max-width:513px;font-size:18px;font-size:1.125rem;font-weight:400;line-height:29px;line-height:1.8125rem;font-family:var(--base-font)}._3Uinu{position:relative}._2kWqR{width:100%}._3fF9S{position:fixed;width:87%;padding-top:4rem;height:100%;bottom:0;left:0;right:0;margin:auto}@media(min-width:1440px){._3fF9S{max-width:78rem}}", ""]);
// Exports
exports.locals = {
	"root": "_2kmMQ",
	"title": "_2ePNx",
	"description": "_1Vl3K",
	"container": "_3Uinu",
	"wrapper": "_2kWqR",
	"groupActive": "_3fF9S"
};
module.exports = exports;
